<template lang="html">
  <div ref="wrapper">
    <v-container grid-list-lg>
      <!-- <v-flex> -->
        
      <v-layout wrap>
        <v-flex
          xs12
          md4
          style="min-width:280px "
        >
          <v-card>
            <v-card-title>Seo</v-card-title>
            <v-card-text>
              <SiInputTextarea
                v-model="wiki.description"
                outlined
                rows="2"
                auto-grow
                hide-detailsx
                label="Description"
                required
                @change="save"
              />
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          md8
          class="si-wiki-content"
        >
          <v-card>
            <v-card-title>
              Wiki
              <v-spacer />
              <v-btn
                v-if="isDirty"
                color="primary"
                @click="save"
              >
                Save unsaved changes
              </v-btn>
            </v-card-title>
            <SiQuill 
              v-model="wiki.body" 
              image-save-path="assets" 
              :anchor-toolbar-ref="$refs.wrapper"
              @blur="save" 
              @image-saved="save"
              @change="isDirty = true"
            />
          </v-card>
        </v-flex>
        <v-flex style="height:2000px" />
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'


import { rtdb } from '@/plugins/firebase'
export default {
  mixins: [ helpers, binder ],
  props: {
    calculatorId: String,
  },
  data () {
    return {
      wiki: {},
      lazyWiki: {},
      isDirty: false,
      top: 112
    }
  },
  computed: {
    ...mapGetters(['_appBarTabs']),
    cases () {
      return this.testResults.length > 0 ? this.testResults : this.testCases
    },
    wikiPath () {
      return `calculators/${this.calculatorId}/wiki`
    },
  },
  watch: {
    '$route.params.sub' () {
      this.bindWiki()
    },
    '$route.params.id' () {
      this.bindWiki()
    },
  },
  beforeMount () {
    this.bindWiki()
  },
  beforeDestroy () {
    this.save()
  },
  mounted () {
    // this.onResize()
  },
  methods: {
    bindWiki () {
      this.loading = false

      this.$unbindAll()
      
      if (this.$route.params.id === 'wiki') {
        const callback = (v) => {
          this.wiki = v
          this.lazyWiki = v
          this.$nextTick(() => this.isDirty = false )
        }
        this.$bindRtdb('wiki', this.wikiPath, { callback })
        // this.$bindxxx(rtdb.ref(this.wikiPath), v => {
        //   // this.onResize()
        //   this.wiki = v
        //   this.lazyWiki = v
        //   this.$nextTick(() => this.isDirty = false )
        // })
      }
    },
    save () {
      this.isDirty = false
      rtdb.ref(this.wikiPath).set(this.wiki)
    },
    // onResize () {
    //   let el = this.$refs.wrapper
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //   if (el) this.top = el.getBoundingClientRect().top + scrollTop
    // }
  }
}
</script>

<style lang="scss">
// .si-wiki-content{
//   h1, h2, h3, h4 {
//     font-weight: 300;  
//   }
//   img { 
//     max-width: 100%;
//   }
// }

</style>
